import {
  ApolloClient,
  gql,
  NormalizedCacheObject,
  useQuery,
} from '@apollo/client';
import {Query} from '../types/generated/graphql';

/**
 * Per-worker per-task-type Firestore counters.  Polls every 60s so
 * the panel reflects fresh deltas without manual refresh; that's
 * tied to the worker's flush cadence — anything faster would just
 * show the same numbers.
 */
export const useGetWorkerFirestoreStats = (
  client: ApolloClient<NormalizedCacheObject>,
  sinceHours: number,
) => {
  type T = Pick<Query, 'getWorkerFirestoreStats'>;
  return useQuery<T, {sinceHours: number}>(QUERY, {
    client,
    variables: {sinceHours},
    fetchPolicy: 'cache-and-network',
    pollInterval: 60_000,
  });
};

const QUERY = gql`
  query getWorkerFirestoreStats($sinceHours: Int!) {
    getWorkerFirestoreStats(sinceHours: $sinceHours) {
      workerId
      hourBucket
      firstSeenAt
      lastSeenAt
      worker {
        workerId
        sha
        shortSha
        branch
        bootedAt
        serviceKey
      }
      totals {
        reads
        writes
        deletes
        jobCount
        totalDurationMs
      }
      byCollection {
        collection
        reads
        writes
        deletes
      }
      taskCounts {
        taskType
        reads
        writes
        deletes
        jobCount
        totalDurationMs
        byCollection {
          collection
          reads
          writes
          deletes
        }
      }
    }
  }
`;
